import React, { useState, useEffect, useRef } from 'react';
import {
  establishEventListeners,
  removeAllListeners,
} from '../services/twilioServices';
import VolumeOffSharpIcon from '@material-ui/icons/VolumeOffSharp';
import VideocamOffSharpIcon from '@material-ui/icons/VideocamOffSharp';
import Typography from '@material-ui/core/Typography';
import PersonSharpIcon from '@material-ui/icons/PersonSharp';

import VideocamSharpIcon from '@material-ui/icons/VideocamSharp';
import VolumeUpSharpIcon from '@material-ui/icons/VolumeUpSharp';
import { participantName } from '../constants/liveStreamHelper';

const Participant = (props) => {
  const [videoTracks, setVideoTracks] = useState([]);
  const [audioTracks, setAudioTracks] = useState([]);

  const [videoEnabled, setVideoEnabled] = useState(true);
  const inactiveClr = '#fff'; //
  const actvClr = '#ffffff'; //D20521
  const [hideSpeaker, setHideSpeaker] = useState(false);
  const [hideVideo, setHideVideo] = useState({
    mute: false,
    color: inactiveClr,
  });
  const [singleMute, setSingleMute] = useState({
    mute: false,
    color: inactiveClr,
  });
  const participant = props.participant;
  const speakerMute = props.speakerMute;
  // const layoutType = props.layoutType;

  const videoRef = useRef();
  const audioRef = useRef();

  const trackpubsToTracks = (trackMap) =>
    Array.from(trackMap.values())
      .map((publication) => publication.track)
      .filter((track) => track !== null);

  useEffect(() => {
    const color = speakerMute ? actvClr : inactiveClr;
    setSingleMute((prevState) => {
      // if (!speakerMute) audioRef.current.muted = false;

      return {
        color: color,
        mute: speakerMute,
      };
    });
  }, [speakerMute]);

  useEffect(() => {
    establishEventListeners(
      participant,
      // setMessages,
      trackpubsToTracks,
      setVideoTracks,
      setAudioTracks,
      setVideoEnabled
    );
    return () => {
      setVideoTracks([]);
      setAudioTracks([]);
      removeAllListeners(participant);
    };
  }, [participant]);

  useEffect(() => {
    const videoTrack = videoTracks[0];
    if (videoTrack) {
      videoTrack.attach(videoRef.current);
      // videoRef.current.play();
      return () => {
        videoTrack.detach();
      };
    }
  }, [videoTracks]);

  useEffect(() => {
    const audioTrack = audioTracks[0];
    if (audioTrack) {
      audioTrack.attach(audioRef.current);
      // audioRef.current.play();
      return () => {
        audioTrack.detach();
      };
    }
  }, [audioTracks]);

  useEffect(() => {
    if (videoRef.current) {
      try {
        // videoRef.current.play();
      } catch (error) {}
    }
  }, [videoRef]);

  // useEffect(() => {
  //   if (audioRef.current) {
  //     try {
  //       audioRef.current.play();
  //     } catch (error) {}
  //   }
  // }, [audioRef]);

  useEffect(() => {
    let timerId = setTimeout(() => setHideSpeaker(true), 1000);

    return () => {
      clearTimeout(timerId);
    };
  }, []);

  const camIconFunc = () => {
    setHideVideo((prevState) => {
      if (prevState.mute) {
        // videoTracks[0]?.attach(videoRef.current);
        return {
          mute: false,
          color: inactiveClr,
        };
      } else {
        // videoTracks[0]?.detach();
        return {
          mute: true,
          color: actvClr,
        };
      }
    });
  };

  const showOverlay = () => {
    return (
      <div
        style={{
          position: 'absolute',
          zIndex: 1,
          width: '100%',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: '#000',
          borderColor: '#fff',
          borderWidth: 0.5,
          borderStyle: 'solid',
        }}
      >
        <PersonSharpIcon style={{ fill: '#fff' }} />
      </div>
    );
  };

  const speakerIcon = () => {
    // const seperatorIndex = participant.identity.indexOf('_') + 1;

    return (
      <div
        style={{
          height: 60,
          position: 'absolute',
          alignSelf: 'flex-end',
          width: '100%',
          zIndex: 2,
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          flex: 1,
          flexGrow: 5,
        }}
      >
        <div
          style={{
            paddingRight: 5,
            cursor: 'pointer',
          }}
          onClick={() => {
            setSingleMute((prevState) => {
              if (prevState.color === actvClr) {
                // audioRef.current.muted = false;
                return {
                  mute: false,
                  color: inactiveClr,
                };
              } else {
                return {
                  mute: true,
                  color: actvClr,
                };
              }
            });
          }}
        >
          {singleMute.mute ? (
            <VolumeOffSharpIcon
              style={{ color: singleMute.color, fontSize: 20 }}
            />
          ) : (
            <VolumeUpSharpIcon
              style={{ color: singleMute.color, fontSize: 20 }}
            />
          )}
        </div>
        <div
          style={{
            paddingLeft: 5,
            cursor: 'pointer',
          }}
          onClick={camIconFunc}
        >
          {hideVideo.mute ? (
            <VideocamOffSharpIcon
              style={{ color: hideVideo.color, fontSize: 20 }}
            />
          ) : (
            <VideocamSharpIcon
              style={{ color: hideVideo.color, fontSize: 20 }}
            />
          )}
        </div>
        <div
          style={{
            position: 'absolute',
            right: 0,
            bottom: 0,
            maxWidth: '80%',
            textTransform: 'capitalize',
            textOverflow: 'clip',
            paddingRight: 3,
          }}
        >
          <Typography variant='caption' component='p' noWrap>
            {/* {participant.identity.substr(0, seperatorIndex - 1)} */}
            {participantName(participant.identity).name}
          </Typography>
        </div>
      </div>
    );
  };

  return (
    <div
      className='Camera'
      style={{
        display: 'flex',
        justifyContent: 'center',
        position: 'relative',
      }}
      onMouseOver={() => setHideSpeaker(false)}
      onMouseLeave={() => {
        setHideSpeaker(true);
      }}
    >
      <video
        ref={videoRef}
        muted
        playsInline
        autoPlay
        style={{
          width: '100%',
          aspectRatio: '4/3',
          objectFit: 'cover',
          ...props?.videoFlip,
        }}
      />
      {props.isPartLocal || hideSpeaker ? null : speakerIcon()}

      <audio
        ref={audioRef}
        // autoPlay
        playsInline
        muted={singleMute.mute ? singleMute.mute : false}
      />
      {videoEnabled || showOverlay()}
      {hideVideo.mute && showOverlay()}

      {props.isPartLocal && props.videoMute ? showOverlay() : null}
    </div>
  );
};

export default Participant;
